import VisuallyHidden from '@reach/visually-hidden';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { Typography } from '../Typography';
import { Address } from './icons';
import { ReachLabels } from './ReachLabels';
import { useStyles } from './styles';

export interface OpeningProps {
  title: string;
  address?: string;
  payRate?: string;
  minWeeklyHours?: number;
  maxWeeklyHours?: number;
  brandName: string;
  jobHours?: string;
  jobType?: string;
  industry?: string;
}

export interface ReachOpeningProps extends OpeningProps {
  showCompensation: boolean;
}

export const ReachOpening: FC<ReachOpeningProps> = ({
  title,
  address,
  payRate,
  minWeeklyHours,
  maxWeeklyHours,
  brandName,
  jobHours,
  jobType,
  industry,
  showCompensation,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <Typography variant="headingMD">{title}</Typography>
        <Typography variant="subtitle" className={classes.colorGray}>
          {brandName}
        </Typography>
      </div>

      {address && (
        <div className={classes.address}>
          <VisuallyHidden>
            <FormattedMessage
              defaultMessage="Address"
              description="Accessibility label for screen readers describing Address icon"
            />
          </VisuallyHidden>
          <Address />
          {address && (
            <Typography variant="subtitle" className={classes.colorGray}>
              {address}
            </Typography>
          )}
        </div>
      )}

      <ReachLabels
        payRate={payRate}
        jobHours={jobHours}
        jobType={jobType}
        industry={industry}
        minWeeklyHours={minWeeklyHours}
        maxWeeklyHours={maxWeeklyHours}
        showCompensation={showCompensation}
      />
    </div>
  );
};
